import * as React from 'react'
import { theme } from '../../theme'

interface Props {
	onClick: () => void
}

export const CloseButton = ({ onClick }: Props) => {
	const [isHovered, setIsHovered] = React.useState(false)

	return (
		<button
			onClick={onClick}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			style={{
				position: 'absolute',
				top: theme.spacing.md,
				right: theme.spacing.md,
				background: isHovered ? 'rgba(0, 0, 0, 0.1)' : 'none',
				border: 'none',
				color: theme.colors.text.primary,
				cursor: 'pointer',
				fontSize: '24px',
				zIndex: 1,
				width: '40px',
				height: '40px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				borderRadius: '50%',
				transition: 'background-color 0.2s',
			}}
		>
			×
		</button>
	)
}
